import styled from 'styled-components';

import { COLORS } from '@/nova/theme/tokens';
import { Text } from '@/nova/components';

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 8px;
  padding-top: 16px;
  border-top: 1px solid ${COLORS.hairline};
`;

export const SectionLabel = styled(Text)`
  font-size: 13px;
  font-weight: 600;
  color: ${COLORS.heading};
`;

export const SiteList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const SiteRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 10px;
  background: ${COLORS.surfaceMuted};
`;

export const SiteMeta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const SiteName = styled(Text)`
  font-size: 13px;
  font-weight: 600;
  color: ${COLORS.text};
`;

export const SiteUrl = styled(Text)`
  font-size: 12px;
  color: ${COLORS.textMuted};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const AddRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;
`;

export const AddFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  min-width: 0;
`;
